import React, { useState } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { CreateView } from './CreateView';
import { BatchView } from './BatchView';
import './Layout.css';

export const Layout: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'create' | 'batch'>('create');

  return (
    <div className="layout-container">
      <Header activeTab={activeTab} onTabChange={setActiveTab} />
      <main className="layout-main">
        {activeTab === 'create' ? <CreateView /> : <BatchView />}
      </main>
      <Footer />
    </div>
  );
};
